module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_c('span', {
    staticClass: "fontch"
  }, [_vm._v("1")]), _vm._v(" TOY SOLDIERS")])]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape",
    attrs: {
      "alt": "images",
      "src": "images/ch00.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("I had never thought about quitting anything until the United States Army Ranger School’s “Mountain Phase” in the rugged hills of Dahlonega, Georgia. By the fortieth day of Ranger School in October 2009, my lifelong dislike of hiking had turned into pure hatred.")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I had to get through only twenty-one more days to earn the Army’s coveted Ranger tab, but after six weeks of constant fatigue, I was just about finished. Like most of my fellow soldiers, I had lost around twenty pounds due to strictly imposed food limits, and hadn’t slept more than four hours a night since Ranger School began. For me, those challenges were nothing compared to hiking up and down Ranger Camp Frank D. Merrill’s ruthless cliffs. The mountains of North Georgia were my kryptonite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the fortieth night, my thirteen-man squad and I were on what we called a “death march,” which started in the dead of night and wouldn’t end until we reached a mock objective at 0500. Thankfully it was neither too hot nor cold in early October, but an unrelenting rainstorm made my wet, muddy boots feel as if they were filled with concrete. Even with my night optical devices (NODs), I could barely see the tree branches that were constantly snapping into my face. Bugs were all over my body and inside my dry, thirsty mouth.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("I knew that these hardships were designed to prepare us for many months of combat in the mountains of Afghanistan, where I would likely deploy after Ranger School. But I was physically and mentally drained, with a stomach buckling in on itself. All I could think about was how much this sucked. My deteriorating legs and body language made it even more obvious that I was struggling.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s wrong?” another Ranger candidate, Staff Sergeant Erick Gallardo, said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hell,” I said while gasping for air. “I can’t take this shit anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean?” he said. “Are you falling asleep?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Guys passing out during simulated missions, even while standing up or marching, was commonplace. For me, though, it was about more than sleep deprivation. I felt like forty straight days of Ranger School’s nonstop chaos had finally broken me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m smoked, man,” I told Gallardo. “I think I’m done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a pause, Gallardo, who had narrowly survived a bullet striking his helmet in eastern Afghanistan’s infamous Korengal Valley, made me an offer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you quit right now, I’ll quit with you,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gallardo had received a Silver Star for his heroic actions as the leader of a 173rd Airborne Brigade Combat Team squad that included Army Staff Sergeant Salvatore Giunta (who would later receive the Medal of Honor). Gallardo had been through a lot worse than the mountains of North Georgia. Even though he had nearly been killed in Afghanistan, Gallardo wanted to return to the battlefield as a platoon sergeant, which required earning the Ranger tab.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If I quit, it wouldn’t just be a huge setback to my military career; it would mess up Gallardo’s future, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get through this damn patrol and sleep on it,” he continued. “If you feel the same way in the morning, we’ll quit tomorrow.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Gallardo gave me the second wind I needed, and out of habit my mind snapped back to a concept that had been drilled into my ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("head since the beginning of Ranger School: leave no man behind. After getting through nearly six hellish weeks, why should I give up and take another soldier down with me? Quitting was contrary to everything I stood for.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The next day, the sun came out for the first time in a long while.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are we quitting today?” Gallardo inquired as we wolfed down our MREs (Meals, Ready to Eat).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Negative,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the next night, I reached a second breaking point during another eleven-hour death march. That made our total time awake twenty-three hours. With one hour to go, I was frantically searching for a piece of lost gear, and soon realized I was hallucinating from exhaustion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My Ranger buddy had hurt his ankle a few meters earlier, which prompted me to grab his tripod and add it to the pile of gear that was already on my back. I was carrying over one hundred pounds, in addition to my M240 machine gun. The enormous weight, combined with the pitch-black darkness and brutal terrain, caused me to trip and fall into the mud—fifteen separate times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each time I fell, I worried that I would accidentally discharge my weapon, which would have resulted in my immediate dismissal from Ranger School. Each time I got up, it became harder and harder to lift the hundred-pound weight on my back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the fifteenth fall, my backpack—or “ruck” as we say in the military—felt lighter. Either my hallucinations were worsening, I thought, or a piece of gear was missing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s when I realized that the tripod had disappeared somewhere in the darkness, along with—in all likelihood—my chances of graduating from Ranger School. Like an accidental gun discharge, losing your Army equipment was a serious offense, and the Ranger Instructors (RIs) had zero sympathy for this scenario.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("For the sixteenth time, I fell down, this time out of complete ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("mental obliteration rather than physical fatigue. The thought of fifteen months of hard work—from US Army Basic Training, Officer Candidate School, and the Basic Officer Leadership Course to Infantry School, Airborne School, and now Ranger School—ending in failure was devastating. Many of my peers did not think highly of an infantry officer without a Ranger tab. I had chosen to undergo what was probably the Army’s toughest training regimen because I wanted to lead soldiers in combat, but in that moment my path to war was muddier than the ground I was lying on.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When I looked up, I could barely make out a familiar face staring down at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get up, Groberg,” Gallardo said. “We’ve got too much fun left; you don’t want to miss it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ranger School challenges everything about a human being. It challenges your mind, your body, your emotions, your leadership, your decision making, and most important, your attitude. As Gallardo demonstrated while sensing my struggles, there was also nowhere to hide. From the RIs to your peers, everybody was watching.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eventually, I found my way to my feet and looked at Gallardo. It’s rare to face a career decision that can clearly change the trajectory of your life, but for me this was one of those defining moments. While thinking about what to do for a few seconds, I forgot where I was.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“You are about to embark upon the Great Crusade, toward which we have striven these many months,” I said in French. “The eyes of the world are upon you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your task will not be an easy one,” I continued. “Your enemy is well trained, well equipped and battle hardened. He will fight savagely.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Seconds later, I moved an army of little green plastic soldiers into formation. In a few moments, they would unleash a furious assault on a nearly identical army of gray plastic men.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have full confidence in your courage, devotion to duty and skill in battle,” I said. “We will accept nothing less than full victory. Good luck!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was quoting General Dwight D. Eisenhower’s famous letter to US troops before the Allied liberation of France, where I was born. As a nine-year-old boy, I was busy reenacting World War II, which I had been obsessed with since learning to read. From a young age, playing with toy soldiers inside my room in the Paris suburb of Achères had been my favorite activity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As my plastic army assaulted Normandy’s heavily fortified shores, which were actually pillows, my voice would frequently change as I pretended to belt out commands from the respective green and gray army commanders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“ATTACK,” I shouted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before long, though, D-Day was interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Flo?” my mother, Klara Groberg, said. “Stop talking to yourself!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not talking to myself,” I said assertively. “It’s the soldiers!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eventually, my mom became so concerned that my pretend violence was influencing my behavior at school that she took me to a doctor. Fortunately, the family physician told her that young boys playing war was nothing to be concerned about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was common culture in France to aspire to one day put on a uniform and become a soldier. In my mind, fighting the bad guys always made sense, and for as long as I could remember, I was fascinated by the concept of defeating an enemy, and in particular moving troops into position for battle. To be honest, I understood—even at a young age—how that could be concerning to a mother.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Despite common dreams, my path to the US Army was different from that of most soldiers, mainly because I was born in France. As American kids grew up in the Reagan, Bush, and Clinton years, my character was primarily molded in the relatively poor suburbs of Paris between 1983 and 1994. I also lived in Spain for a short time and frequently visited Algeria, where my mother was born and raised before she moved to France and eventually met my father, Larry Groberg.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom first took me to Algeria when I was three months old. I was the grandparents’ first grandchild (albeit my mom has eleven siblings), and I had nearly died in the hospital after being born three months premature. Therefore, my mom bringing me to North Africa, where she had grown up during the brutal Algerian War in the 1950s, was a monumental moment for my family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My uncle, Abd Alillah Lahreche (who went by Abdou), was ecstatic upon my early arrival. To this day, my mom, the eldest sibling, can vividly recall handing me over to her younger brother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am your Uncle Abdou,” he said in Arabic while staring straight into my little eyes. “You are my Flo.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though he had no experience caring for children, let alone babies when he was only eighteen years old, Uncle Abdou treated me as if I were his own son. On that very first day, he held me on his chest for several hours while I took a nice, long nap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quickly, Uncle Abdou became that one person that all young children cling to. He took his role as a guardian as seriously as his name, which means “servant of God” in Arabic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are my Flo,” he repeated. “I won’t let anything happen to you.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Starting in my preschool years, I would regularly visit my grandparents, aunts, and uncles in Algeria, but my connection to Uncle Abdou became so strong that even when my mom and I would make unannounced visits, my uncle had already told other family ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("members about my impending arrival. We always joked that Uncle Abdou knew when I was coming to visit because of the unwavering bond we shared.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Abdou also made it a priority to visit my family in France during a week-long gap between the start of French and Algerian schools. On the day of his arrival, I would sit atop the steps leading to my family’s apartment and wait for my idol. Regardless of whether my wait lasted minutes or hours, I was always nervous that he wouldn’t appear. I wouldn’t eat, drink, or play with my toy soldiers until I saw him open the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After Uncle Abdou would arrive and give me a hug and kiss on the forehead, without fail he would say “You are my Flo” . . . every single time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are my Abdou,” I would respond.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over dinners that were more like feasts, I overheard stories about the horrors of the war in Algeria. Uncle Abdou didn’t have a military background, but he still managed to impart crucial values about good and evil to me throughout those dinners. My uncle also taught me that liberty wasn’t granted to all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Freedom has to be earned,” Uncle Abdou said. “Sometimes, you have to fight for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My uncle was a devout Muslim. My mom grew up in the same household and was brought up the same way, but I was not raised Muslim. Instead I followed my father’s Lutheran faith.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite my Christian upbringing, my parents still encouraged me to attend the mosque with Uncle Abdou, where I would watch him carry out Islam’s most sacred traditions. It took only one visit for me to develop enormous respect for my uncle’s authentic commitment to his faith.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("By the time my family moved across the Atlantic to the Chicago suburb of Palatine, Illinois, when I was twelve, a radical Islamist organization known as GIA—or Groupe Islamique Armé in ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("French—was causing mass chaos as it terrorized innocent Algerian men, women, and children beginning in 1992.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As I heard about what was happening in Algeria while I was struggling to adapt in an unfamiliar country, I also learned that my uncle’s lesson about freedom was not empty rhetoric. After watching in horror as fellow Algerians were murdered, raped, and dismembered, Uncle Abdou swore an oath to fight terrorism as a soldier in the Algerian army.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom didn’t tell me until later, but when he joined the military, my uncle told her that he wasn’t afraid of dying for his country. He was, however, deeply fearful of being tortured by the ruthless GIA terrorists, whose crimes against humanity were similar to the present-day barbarism of the Islamic State, or ISIS.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to die the right way,” Uncle Abdou told my mom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though I was still a boy, my uncle’s courage was deeply inspirational. Not only was Uncle Abdou like a big brother; he had fulfilled my personal dream of becoming a soldier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shortly after my twelfth birthday, we moved from the Chicago area to the Washington, D.C., suburb of Bethesda, Maryland. My English was getting better, but still needed a lot of work. Just as in Illinois, the combination of ESL (English as a Second Language) classes and competitive sports probably did the most to speed my adaptation. Still, America was new and different. Adjusting was not easy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was an exciting, bustling time to be an American teenager as the economy boomed and the country prepared to host the 1996 Summer Olympics in Atlanta, but when you don’t know much English, you feel like an outsider. Learning a new language was the biggest challenge of my youth, so I attacked it with the same vigor as in those mock D-Day invasions. While we spoke French inside our new home in Maryland, my mom and dad had a strict rule: as soon as we stepped out the front door, we spoke only English.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("I realized my English had improved a great deal when I began to watch and understand classic war movies in English, without subtitles. I don’t suppose most people think of the early "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Rambo")]), _vm._v(" films and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Platoon")]), _vm._v(" being tools for teaching a language, but that’s exactly what those movies did for me.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I tried to keep in touch with Uncle Abdou, but it became difficult with him fighting the GIA on Algeria’s front lines. When we had last spoken a few months earlier, on Christmas Eve, he had told me that while war is terrible and scary, he knew that fighting evil was the right thing to do. Even though I was an easily distracted teenager who didn’t fully understand how much danger my uncle was facing, he was a constant source of inspiration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Uncle Abdou and the Algerian army fought halfway around the world in February 1996, I went on a school trip to a Smithsonian museum with my classmates. When I returned to Bethesda, I noticed that my mom wasn’t there, which was very unusual for our regular routine. I asked my dad where she was, and he said that I would be able to talk to her soon. I believed my father, but also sensed trepidation in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before I knew it, my dad and I were sitting in our living room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("What is going on? Am I in trouble? Where is Mom?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Florent, I know that this is going to be hard for you to hear,” my father began.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Did something happen to my mother?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your mom is in Algeria,” my dad said. “She is there for a funeral.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("What?")]), _vm._v(" My head started spinning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s your Uncle Abdou,” my father said. “He’s been killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My vision narrowed until it became a pinhole of light. I suddenly had no control over my body or my emotions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few seconds later, I fainted and hit the floor. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("This can’t be happening.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("What I still didn’t know was that early that morning, my mom had had to be sedated prior to her painful flight to Algeria. The death of her brother had destroyed her, much as it was now destroying me.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I was told that Uncle Abdou’s murder came at the hands of the GIA. While my father did his best to comfort me, the details of Uncle Abdou’s death were gruesome and inhumane. As a twelve-year-old, I learned my uncle wasn’t just killed in battle: he was beheaded, dismembered, and his body parts shipped back to my extended family in a box.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As my mother would tell me upon returning from Algeria, the only saving grace was that Uncle Abdou had been shot through the heart. That was my mom’s only comfort after her brother had expressed his fear of being tortured. According to Abdou’s religion, he was in a better place now. In Islam, life on earth is only preparation for the eternal life to come. The Muslim faith dictates that Allah will balance the good deeds a person has done in his or her life against the bad deeds. If the good outweighs the bad, the person will go to paradise: a place of joy and bliss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t go to school for an entire week after being told about Uncle Abdou’s death because I was so upset. With my mom still in Algeria, my dad stayed home from work because he was worried about me. He had never seen his only son experience these kinds of emotions, and frankly, I didn’t know how to handle them. Never in my life had I felt that kind of piercing grief and unbridled rage. I didn’t want to sit around mourning my uncle. I wanted to find his killers and bring them to justice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s hard to remember much else from that week other than one moment. As soon as I walked in my room and wiped away the tears, I went straight to my drawer and pulled out those two plastic bags full of green and gray soldiers. Bags in tow, I walked downstairs, past my dad.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“Flo, where are you going?” he asked as I walked out the back door. Defiantly, I ignored him. A few moments later, I had started burning my toy soldiers in a makeshift fire pit.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As the green and gray plastic melted, I had a paradigm shift in the way I thought about religion. I remember thinking, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("How can people use religion to justify murder, rape, and dismemberment?")]), _vm._v(" I did not associate myself with a religion after that day because too many used it as fuel for violence, but I continued to believe in God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("War was no longer a game. From that night forward, I was finished with toy soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Staring through the darkness up at Staff Sergeant Gallardo, I knew it was time to decide whether I should quit Ranger School and head back to my regular Army unit, or keep moving forward. Mountain Phase had absolutely kicked my ass, but if I decided to leave, this friend and Afghanistan war veteran was leaving North Georgia with me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, I couldn’t find that damn tripod that had fallen off my ruck, which would almost certainly result in me getting kicked out of Ranger School anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are we quitting?” Gallardo asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before I could answer, another soldier interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey bro, do you know why you keep falling?” he said. “The tripod is dangling from your ruck, so you’re dragging it through the mud.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This revelation was so obvious it was almost comical. It sent waves of energy through my tired body and mind. I hadn’t lost the tripod after all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before thanking our observant fellow soldier, I answered Gallardo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Negative,” I said. “Let’s keep pushing.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Covered in dark brown mud and finishing the death march in the black of night, I was suddenly the happiest soldier in the world. It was 0400, so if I could make it through the next hour, I knew that I would conquer the last three weeks of Ranger School, too.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“We can do this,” I said to the guy walking next to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who are you talking to, Groberg?” a squad member walking behind me asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mickey Mouse,” I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Honest to God, the figure to my left looked exactly like a costumed Mickey Mouse you would see mobbed by adoring children at Disney World. When I reached out, I could even touch his white, puffy hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bro, you’re hallucinating,” another soldier said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I no longer cared. The death march was almost over, and as I described Mickey Mouse’s big, black ears, my Ranger School brothers shared a hearty laugh at my expense. We were all relieved to experience that brief moment of humor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When my teammates, Mickey, and I reached our objective, we collapsed like a house of cards. The RIs told us that the next day would start in exactly twenty-five minutes, which left us with two choices: eat our MREs or take a quick nap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During my time at Ranger School, I learned the difference between what we called a “Hungry Ranger” and a “Sleepy Ranger.” Myself, I tended to be a Hungry Ranger, so the choice was easy: I always picked eating over sleeping. Mickey Mouse slowly faded as desperately needed food and water began to stabilize my system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the hallucinations finally subsided, I pulled a piece of unread mail out of my pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inside the envelope was a letter from my dad, which was scribbled onto bar napkins. In it, he described drinking a beer and eating a steak while watching the Chicago Bears, which had been our favorite NFL team since we first moved to Illinois from France.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("To be honest, the contents of his letter kind of pissed me off, as I would have given anything to wash a New York strip down with a cold one. I would remind him about that letter for years to come. Still, my dad had taken the time to write me, which meant a lot. As I enjoyed those twenty-five minutes of downtime, I allowed myself to mentally escape Ranger School.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I was a freshman at the University of North Carolina–Wilmington on September 11, 2001. Like anyone old enough to remember, I was rocked by the first images of the World Trade Center’s burning North Tower, which I saw on my dorm’s shared television. As black smoke billowed up into the skies above lower Manhattan and the Statue of Liberty, which had been a gift from the country where I was born, I suddenly felt the same sense of rage I experienced on the night my uncle was murdered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead of retreating to my room to find something to burn, I picked up the phone and called home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom, they did it again,” I said as soon as she answered. I was thinking of Uncle Abdou.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Flo?” she said with the same concerned voice I heard whenever she was worried about me. “Are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re knocking down the World Trade Center in New York,” I said in French. “Turn on the TV.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she started watching, the World Trade Center was still standing, and the South Tower hadn’t yet been struck. Even though it was impossible to conclude that 9/11 was a terrorist event from the very beginning, I just "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("knew.")]), _vm._v(" Perhaps the awful experience of losing an uncle to the same evil ideology gave me the preconceived notion. For whatever reason, I had no doubt that America was being attacked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("I heard my mom drop to the floor in anguish when the second ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("plane hit. Five short years after she had been in Algeria for Uncle Abdou’s funeral and witnessed the devastation to her homeland as a result of the GIA, like-minded terrorists were attacking her new country just a few hundred miles from where she lived. I, too, began to panic when American Airlines Flight 77 crashed into the Pentagon.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, Osama bin Laden and his psychotic followers were not the same terrorists who had dismembered my uncle in Algeria, but al Qaeda and the GIA were one and the same to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom, put Dad on the phone,” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After my father picked up the phone, I told him that I was going to quit college and enlist in the United States Army as a Ranger. The terrorists had done this to my family in 1996 and now to my adopted country. There was no way that I was going to stand on the sidelines and not be a part of the solution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My father silently listened to me vent about my frustration and anger. Once I was done, he told me that he was angry as well, but it was in these specific moments that I really had to take a step back and not make a decision based on emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He then asked me if I remembered what he made me promise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though I couldn’t remember, my father made sure to remind me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When I gave you the name Groberg, I told you that it came with a specific requirement,” he said. “When we start something, we finish it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know that you are angry,” he continued. “So are millions of Americans, and guess what? We all should be. But if you decide to quit school to join the military, you will always find a reason to quit anything that you have started.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My dad’s advice—delivered on September 11, 2001—was profound.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("“You are a man and you can make your own decisions,” he said ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("in conclusion. “Remember: the tough decision usually isn’t the most popular. But I expect you to make the right one.”")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My father was correct. He never let me down and always took the time to teach the right lessons. In this case, I might have hated his answer, but I nevertheless understood his perspective.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as I hung up the phone, I heard singing. I realized it was coming from the television, where Republican and Democratic members of Congress—hand in hand on the steps of the United States Capitol—were singing “God Bless America.” My throat clenched and my eyes welled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That night, I went to bed understanding that I wouldn’t join the military the following morning, but my future in the military was solidified. I would put on a military uniform sooner rather than later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following the attacks of September 11, 2001, I was no longer a guy from France. From that day forward, I was an American.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After finishing Mountain Phase and then successfully navigating the swamps of Florida, which marked Ranger School’s final challenge, I embraced my mom and dad after the US Army Ranger tab was pinned on my shoulder during a ceremony at Fort Benning. I also finally got to sit down and eat! I had never been that hungry in my life, and for about a week, this Hungry Ranger ate every meal as if his life depended on it. I also made my dad take me out on the town for the steak and beer he had joked about in that letter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of the three-hundred-plus soldiers in our original Ranger School class, just sixty-nine of us graduated. The fact that I was one of them meant a great deal to my parents, who knew that my path to becoming a soldier started because of Uncle Abdou and was cemented on 9/11. They were also naturally scared for my safety, but seeing me earn the Army Ranger tab made them proud.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Ranger School is a leadership school, but in my opinion it is also a test of character. It wasn’t any ordinary camping trip, but a life lesson learned through trial by fire. I learned a lot about myself and my peers during those two trying months.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("With the support of my Ranger buddies, I had made it through the hardest challenge of my life. Getting to celebrate the achievement with my family and brothers-in-arms like Staff Sergeant Gallardo was a privilege. After so much hunger, exhaustion, and self-doubt, I knew that those sixty-one days of hell had made me a better soldier, and a better person. To this day, I live by the US Army Ranger Creed.")]), _vm._v(" "), _c('p', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Recognizing that I volunteered as a Ranger, fully knowing the hazards of my chosen profession, I will always endeavor to uphold the prestige, honor, and high esprit de corps of the Rangers.")])]), _vm._v(" "), _c('p', {
    staticClass: "quotesi"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Acknowledging the fact that a Ranger is a more elite soldier who arrives at the cutting edge of battle by land, sea, or air, I accept the fact that as a Ranger my country expects me to move further, faster and fight harder than any other soldier.")])]), _vm._v(" "), _c('p', {
    staticClass: "quotesi"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Never shall I fail my comrades. I will always keep myself mentally alert, physically strong and morally straight and I will shoulder more than my share of the task whatever it may be, one-hundred-percent and then some.")])]), _vm._v(" "), _c('p', {
    staticClass: "quotesi"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Gallantly will I show the world that I am a specially selected and well-trained soldier. My courtesy to superior officers, neatness of dress and care of equipment shall set the example for others to follow.")])]), _vm._v(" "), _c('p', {
    staticClass: "quotesi"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Energetically will I meet the enemies of my country. I shall defeat them on the field of battle for I am better trained and will fight with all my might. Surrender is not a Ranger word. I will never leave a fallen comrade to fall into the hands of the enemy and under no circumstances will I ever embarrass my country.")])])]), _c('p', {
    staticClass: "quotesi"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Readily will I display the intestinal fortitude required to fight on to the Ranger objective and complete the mission though I be the lone survivor.")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "quotesib"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Rangers lead the way!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just six weeks after graduating Ranger School, I was in Afghanistan.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f7044d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 78
// module chunks = 0